export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Votre réparateur de fenêtre à Bischheim
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Bischheim, à la porte de Strasbourg, concentre une grande diversité d'habitats : immeubles, logements sociaux et pavillons. Cette mixité génère des fenêtres de toutes époques et de toutes marques. Nos techniciens réparent chez vous, sans remplacer la menuiserie entière.
            </p>
            <p>
              Bischheim, intégrée à l'Eurométropole de Strasbourg, est un tissu urbain dense où se mêlent immeubles collectifs, logements sociaux et pavillons familiaux. Les fenêtres sont aussi variées que l'habitat : PVC récent, aluminium d'immeuble, bois ancien de maison de ville. Nous connaissons bien Bischheim et réparons chez vous, sans remplacer la fenêtre entière.
            </p>
            <p>
              À 5 minutes de Strasbourg, Bischheim bénéficie d'une réactivité de premier ordre. Le déplacement est gratuit, le devis est gratuit, la pièce de remplacement est incluse et chaque réparation est garantie 10 ans. Nos techniciens connaissent le parc immobilier local, des barres d'immeubles aux petites rues pavillonnaires.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}